"use strict";
import "src/decidim/map/provider/here";
import "src/decidim/map";
